export default __webpack_public_path__ + "static/media/header_image.d027875a.jpg";